import studentQuotaExceededComponent from './quota-exceeded.component';


export default angular
  .module('fizyweb.paycell.student.quotaExceeded', [])
  .component('quotaExceeded', studentQuotaExceededComponent).name;



// WEBPACK FOOTER //
// src/app/components/student/quota-exceeded/quota-exceeded.module.ts